module.exports = __webpack_public_path__ + "img/escadaria_02.fd907d47.jpg";